'use client';

import { GetUiDeviceSurface } from 'lib/screenResolution';

const DOMContextProvider = ({ children }) => {
  const surface = GetUiDeviceSurface();
  return <div className={`surface-${surface}`}>{children}</div>;
};

export default DOMContextProvider;
